import React, { useRef } from "react";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Select from "react-select";
import fileUpload from "../../../../Assets/MainComponent/fileUpload.svg";
import {
    setTrackingSubCategoryEmpDatasEmpAction, setTrackingParentDatasEmpAction,
    setHelpDeskEmpApplyEmpDatasEmpAction
} from "../../../../Redux/Slice"
import { store } from "../../../../Redux/Store"
import { toast } from "react-toastify";
import ImageCropper from "../../ReactcropOverall/Imagecrop";
import Button from "@mui/material/Button";
import { PresentUrl } from "../../../../text/apidata";
import axios from "axios";
import PlusIcon from "../../../../Assets/AppComponent/Asset 9.svg"
import minus from "../../../../Assets/AppComponent/Asset 10.svg"
import useDebouncedEffect from 'use-debounced-effect';

const HelpDeskCreate = (props) => {
    const {
        show,
        setShow,
        editPayload,
        refresh,
        selectedPerformanceId,
        setEditPayload,
        PageIndex,
        status,
        search
    } = props;
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const state = useSelector((state) => state)
    const leaveTypes = useSelector((state) => state.LeaveTypeData.LeaveTypeData);
    const [imgsrc, setImgsrc] = useState();
    const [forindex, setforindex] = useState();

    const [selectedLeave, setSelectedLeave] = useState("");
    const userId = useSelector(
        (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
    );


    const [data, setData] = useState({
        category_id: "",
        description: "",
        parent_id: "",

    });
    const [fieldErrors, setFieldErrors] = useState({
        category_id: "",
        description: "",
        parent_id: "",


    });
    const [categoryerrr, setcatoryerr] = useState("");
    const [categoryErrs, setCategoryErrs] = useState("");
    const [purposeErr, setPurpoesErr] = useState("");
    const fileInputRef = useRef();
    const updateAvatar = (imgSrc) => {
        fileInputRef.current = imgSrc;
    };
    const [images, setImages] = useState([]);
    const [number, setNumber] = useState(1);
    const [imageFiles, setImageFiles] = useState();
    const [documentPassed, setdocumentPassed] = useState(false)
    const [imagesFile, setImagesFile] = useState([]);
    const [CroppImageView, setCroppImageView] = useState(false);
    const [imagesPost, setImagesPost] = useState([]);
    const [inputFields, setInputFields] = useState([
        {
            Files: "",
            file: "",
        },
    ]);
    const [PresentUrls, setPresentUrls] = useState([])
    const [updated, setupdatefile] = useState(false);
    const [ParentOPtion, setParentOptions] = useState([]);
    const [CategoryOPtion, setCategoryOptions] = useState([]);
    const [Searched, setSearched] = useState({
        parentse: "",
        CategorySearch: ""
    })
    const initialDebouanceSearch = {
        parentse: "",
        CategorySearch: ""
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    
   

    useEffect(() => {
        const payload = {
            search: Searched.parentse,
            page_size: 10,
            page: 1
        }
        dispatch(setTrackingParentDatasEmpAction(payload))
    }, [Searched.parentse])


    useEffect(() => {
        if (data.parent_id != "") {
            const payload = {
                search: Searched.CategorySearch,
                page_size: 10,
                page: 1,
                parent: data.parent_id
            }
            dispatch(setTrackingSubCategoryEmpDatasEmpAction(payload));
        }
    }, [Searched.CategorySearch, data.parent_id])

    console.log(state.TrackingParentEmp.TrackingEmpDatasParent, "apsiupoasi TrackingParentEmp");
    useEffect(() => {
        if (state.TrackingParentEmp.TrackingEmpDatasParent != undefined) {
            let objectArray = [];
            state.TrackingParentEmp.TrackingEmpDatasParent.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.name.toUpperCase(),
                });
            });
            setParentOptions(objectArray);
        }
    }, [state.TrackingParentEmp.TrackingEmpDatasParent, Searched.parentse]);

    useEffect(() => {
        if (state.TrackingsubCategorytEmp.TrackingEmpDatasSubcategoryEMP != undefined) {
            let objectArray = [];
            state.TrackingsubCategorytEmp.TrackingEmpDatasSubcategoryEMP.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.name.toUpperCase(),
                });
            });
            setCategoryOptions(objectArray);
        }
    }, [state.TrackingsubCategorytEmp.TrackingEmpDatasSubcategoryEMP, Searched.CategorySearch, data.parent_id]);

    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[index] = "";
            return newImages;
        });
        setInputFields(values);
        const updatedImagesFile = [...imagesFile];

        updatedImagesFile[forindex] = "";
        setImagesFile(updatedImagesFile);
    };
    const handleAddFields = (index) => {
        if (inputFields.length != 10) {

            const values = [...inputFields];
            values.push({
                Files: "",
                file: "",
            });

            setInputFields(values);
            setImages((prevImages) => {
                const newImages = [...prevImages];
                newImages[index] = "";
                return newImages;
            });
        }
    };

    function getCroppedImg(imageRef, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            imageRef.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );


        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                const croppedFile = new File([blob], fileName, {
                    type: "image/jpeg",
                });
                var file = croppedFile;
                if (croppedFile) {
                    setTimeout(() => {
                        setCroppImageView(false)

                    }, 0);
                }
                const valuesFile = [...inputFields]; ///file
                console.log(valuesFile, "asdpaspod oiasud valuesFile");

                valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
                setInputFields(valuesFile);

                const generateRandomNumber = () => {
                    return Math.floor(Math.random() * 100000);
                };

                const createPresentData = (croppedFile) => {
                    const randomNumber = generateRandomNumber();
                    const formattedFilename = `onboarding/tracking/cropped${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
                    const Presentdata = {
                        multiple_files: [
                            {
                                filename: formattedFilename,
                                file_type: croppedFile.type,
                            },
                        ],
                    };

                    return Presentdata;
                };

                const Presentdata = createPresentData(croppedFile);

                setupdatefile(true);

                axios({
                    url: PresentUrl,
                    method: 'post',
                    data: Presentdata,
                    headers: {
                        Authorization:
                            "Bearer " +
                            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
                    },
                })
                    .then((response) => {
                        console.log('Files uploaded successfully:', response.data);
                        const uploadedFiles = response.data.data;

                        const newUrls = uploadedFiles.map(file => ({
                            url: file,
                            type: croppedFile.type,
                            putfiles: croppedFile

                        }));
                        setPresentUrls(prevUrls => {
                            const updatedUrls = [...prevUrls];
                            updatedUrls[forindex] = newUrls[0];
                            return updatedUrls;
                        });



                        const updatedImageUrl = String(response.data.data).split("?")[0]
                        const values = [...inputFields]; ///----result
                        values[forindex].certificate = String(response.data.data).split("?")[0];
                        setInputFields(values);

                        setImagesFile(prevUrls => {
                            const updatedUrls = [...prevUrls];
                            updatedUrls[forindex] = String(response.data.data).split("?")[0];
                            return updatedUrls;
                        });

                    }).catch((error) => {
                        console.error('Error uploading files:', error);
                    });

                setdocumentPassed(true);



                var fileBase = croppedFile;
                var reader = new FileReader();
                reader.onloadend = function () {
                    setImages((prevImages) => {
                        const newImages = [...prevImages];
                        newImages[forindex] = reader.result;
                        return newImages;
                    });
                    const values = [...inputFields];
                    values[forindex].Files = reader.result;
                    setInputFields(values);
                    setImages((prevImages) => [...prevImages, reader.result]);
                    setImagesPost((prevImagesPost) => [
                        ...prevImagesPost,
                        { key: `document${number}`, file: croppedFile },
                    ]);


                    console.log(inputFields, "inputFields");
                };
                reader.readAsDataURL(fileBase);
                //  }

                blob.name = fileName;
                resolve(croppedFile);
            }, "image/jpeg");
        });
    }


    const handleInputChange = (index, event) => {
        const values = [...inputFields];
         
        if (event.target.name === "file") {
            setImageFiles(event)
            setCroppImageView(true);
            setupdatefile(true);



            const file = event.target.files[0];
            const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            const MIN_DIMENSION = 150;
            console.log(event.target.name ,"event.target.name" , file && allowedTypes.includes(file.type));

            if (file && allowedTypes.includes(file.type)) {
                if (file.size > maxSize) {
                    setCroppImageView(false);
                    toast.error("File size exceeds 10MB. Please upload a smaller image.");
                } else {
                    const reader = new FileReader();
                    reader.addEventListener("load", () => {
                        const imageElement = new Image();
                        const imageUrl = reader.result?.toString() || "";
                        imageElement.src = imageUrl;

                        imageElement.addEventListener("load", (imgEvent) => {
                            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

                            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                                toast.error("Image must be at least 150 x 150 pixels.");
                                setCroppImageView(false);
                                return;
                            }
                        });
                    });
                    reader.readAsDataURL(file); // Read the file as a data URL
                }
            } else {
                setCroppImageView(false);
                toast.error("Please upload an image file (jpg, jpeg, png, svg).");
            }
        }

        setInputFields(values);
    };

    
    const handleInputChangeSearch = (val) => {
        setSearchDebounance({
            ...SearchDebounance,
            parentse: val,
        }
        )
    }

    const handleClose = () => {
        setEditPayload("");
        setShow(false);
        setData({
            category_id: "",
            description: "",
        });
        setFieldErrors({
            category_id: "",
            description: "",
        });
        setSelectedLeave("");
    };
    const handleSubmit = () => {

        var a = 0;
        if (data.parent_id == "") {
            setcatoryerr("*Please select Category")
            a = 1;
        }

        if (data.category_id == "") {
            a = 1;
            setCategoryErrs("*Category is requried")
        }
        if (data.description == "") {
            a = 1;
            setPurpoesErr("*Description is requried")
        }

        if (a == 0) {
            const fetchUploadFiles = async () => {
                await Promise.all(PresentUrls.map(async (item, index) => {
                    try {
                        if (item != undefined && item != null) {

                            const response = await fetch(item.url, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': item.type,
                                    "x-amz-acl": "public-read"
                                },
                                body: item.putfiles,
                            });

                            if (!response.ok) {
                                throw new Error(`HTTP error! Status: ${response.status}`);
                            }

                            if (PresentUrls.length == index + 1) {

                                let formdatas = {
                                    request_type: "request",
                                    from_user: data.description,
                                    category_id: data.category_id,
                                    documents: [],
                                    user_id: userId
                                }

                                imagesFile.forEach((element, index) => {
                                    if(element != null && element != undefined && element !=""){
                                    formdatas.documents.push(element)
                                    }
                                });


                                const payload = {
                                    data: formdatas,
                                    //   formdatas: formdatas,
                                    //   API: 1,
                                    //   GetFilter: GetFilter

                                }

                                dispatch(setHelpDeskEmpApplyEmpDatasEmpAction(payload))
                                setShow(false)
                                setPresentUrls([]);


                            }

                        }
                    } catch (error) {
                        console.error('Error uploading files:', error);
                    }
                }));
            };

            if (documentPassed == true && a == 0) {
                fetchUploadFiles()

            }

            else if (documentPassed == false && a == 0) {

                const payload = {
                    data: {
                        request_type: "request",
                        from_user: data.description,
                        category_id: data.category_id,
                        documents: [],
                        user_id: userId

                    }

                }

                dispatch(setHelpDeskEmpApplyEmpDatasEmpAction(payload))
                setShow(false)

            }

        }
    };

    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...Searched,
                    parentse: SearchDebounance.parentse,
                    CategorySearch:SearchDebounance.CategorySearch
                });
    
            }
        },
        500,
        [SearchDebounance]
    );
    const HandleCategory = (e) => {

        setData((prev) => ({
            ...prev,
            category_id: e.value,
        }));
        setCategoryErrs("");
    }

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div className="leaveApplyWrapper ">
                    <div className="leaveApplyWrapperRows">
                        <h3> Help Desk</h3>

                    </div>

                    <div className="form-group row" style={{ height: "100%" }}>
                        <div className="col-sm-3">
                            <label className="form-label" htmlFor="leaveDate">
                                Category <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                placeholder="Select a Category type"
                                isSearchable={true}
                                id="leaveType"
                                options={ParentOPtion}
                                onChange={(e) => {
                                    setData((prev) => ({
                                        ...prev,
                                        parent_id: e.value,
                                    }));
                                    setSelectedLeave(e);
                                    setcatoryerr("");
                                }}
                                onInputChange={handleInputChangeSearch}


                                style={{ zIndex: "999" }}
                            />
                            <p className="Error">{categoryerrr}</p>


                        </div>
                        {data.parent_id != "" && (
                            <>

                                <div className="col-sm-3">

                                    <label className="form-label" htmlFor="leaveDate">
                                        Sub Category <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Select a Category type"
                                        isSearchable={true}
                                        id="leaveType"
                                        options={CategoryOPtion}
                                        onChange={(e) => {
                                            HandleCategory(e)
                                        }}
                                        style={{ zIndex: "999" }}
                                        onInputChange={(e) => {
                                            setSearchDebounance({
                                                ...SearchDebounance,
                                                CategorySearch: e,

                                            })
                                        }}

                                    />
                                    <p className="Error">{categoryErrs}</p>
                                </div>



                                <div className="col-sm-3 customInputRem">
                                    <label className="form-Header" htmlFor="leaveDate">
                                        Description<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        className="formDatas"
                                        type="text"
                                        value={data.description}
                                        onChange={(e) => {
                                            setData((prev) => ({
                                                ...prev,
                                                description: e.target.value,
                                            }));
                                            setPurpoesErr("");
                                        }}
                                    />
                                                                    <p className="Error">{purposeErr}</p>
                                </div>

                                <div className="col-sm-12 Documentfiled">
                                    <div style={{ display: "flex" }}>

                                        <label
                                            for="validationCustom01"
                                            class="form-label"
                                            style={{ width: "100%" }}
                                        >
                                            Documents
                                        </label>
                                    </div>

                                    <div style={{ display: "flex" }}>
                                        {inputFields.map((inputField, index) => {
                                            return (
                                                <Fragment key={`${inputField}~${index}`}>
                                                    <div
                                                        className="form-group "
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <div
                                                            className=" btn  StatusList"
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                alignContent: "center",
                                                                gap: "20px",
                                                            }}
                                                        >

                                                            <div
                                                                className="col-sm-7"
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "flex-start",
                                                                    gap: "10px",
                                                                    flexDirection: "column",
                                                                }}
                                                            >
                                                                {inputField.Files &&
                                                                    <img
                                                                        // src={images[0]}
                                                                        src={inputField.Files}
                                                                        style={{
                                                                            width: "150px",
                                                                            height: "150px",
                                                                            border: "1px solid #000",
                                                                            borderRadius: "10px",
                                                                        }}
                                                                    />
                                                                }

                                                                <Button
                                                                    className="doctorupload"
                                                                    variant="contained"
                                                                    component="label"
                                                                    style={{
                                                                        background: "#234492", color: "#fff",
                                                                        fontSize: "11px !important"
                                                                    }}
                                                                >

                                                                    <input
                                                                        type="file"
                                                                        hidden
                                                                        accept="image/png, image/jpeg"
                                                                        name="file"
                                                                        // onChange={(e) => handleFiles(e)}
                                                                        onChange={(event) => {
                                                                            setforindex(index);
                                                                            handleInputChange(index, event);
                                                                        }}
                                                                        ref={fileInputRef}

                                                                    />
                                                                    Upload Image
                                                                </Button>
                                                            </div>

                                                            <div className="col" style={{ display: "flex", gap: "19px" }}>

                                                                <>
                                                                    <button
                                                                        className="DeclineStatus"
                                                                        disabled={index === 0}
                                                                        onClick={() => {
                                                                            handleRemoveFields(index);
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            <img src={minus} />
                                                                        </span>
                                                                    </button>
                                                                    {index === 0 ?
                                                                        // <div
                                                                        //   className="AddingButton"
                                                                        //   onClick={(index) => {
                                                                        //     if(index +1 != 5)
                                                                        //     handleAddFields(index);
                                                                        //   }}
                                                                        //   style={{
                                                                        //     backgroundColor: "#F58837",
                                                                        //     fontSize: "19px",
                                                                        //     width: "  20px",
                                                                        //     height: "20px ",
                                                                        //     borderRadius: "50%",
                                                                        //     display: "flex",
                                                                        //     alignItems: "center",
                                                                        //     justifyContent: "center",
                                                                        //   }}
                                                                        // >
                                                                        //   <span className="PlusButton">
                                                                        //     <img src={PlusIcon} />
                                                                        //   </span>
                                                                        // </div>
                                                                        <div
                                                                            className="AddingButton"
                                                                            onClick={() => {
                                                                                if (inputFields.length < 5) {
                                                                                    handleAddFields();
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: "#F58837",
                                                                                fontSize: "19px",
                                                                                width: "20px",
                                                                                height: "20px",
                                                                                borderRadius: "50%",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                cursor: inputFields.length >= 5 ? "not-allowed" : "pointer",
                                                                            }}
                                                                        >
                                                                            <span className="PlusButton">
                                                                                <img src={PlusIcon} alt="Add" />
                                                                            </span>
                                                                        </div>

                                                                        : null}

                                                                </>

                                                            </div>


                                                        </div>
                                                    </div>


                                                </Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </>

                        )}
                    </div>
                    <div className="ReimbursementButttonEmp" style={{ marginBottom: "30px" }}>

                        <button class="btn CancelBtn" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            class="btn "
                            type="submit"
                            onClick={(e) => {
                                handleSubmit();
                            }}
                        >
                            Submit
                        </button>

                    </div>
                </div>

            </div>
            {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={imageFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
        </>

    )
}

export default HelpDeskCreate